var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('router-link',{attrs:{"to":"/act3/main"}},[_c('div',{staticClass:"main",staticStyle:{"background-image":"url(static/img/act/3/banner.jpg?v=2)"}},[_c('img',{staticClass:"act-3-banner-btn-show",attrs:{"src":"static/img/act/3/btn-show.png"}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b815823","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/act/3/Banner.vue
// module id = null
// module chunks = 